import dataservice from "../services/dataservice";
import type { PendingPosSold } from "./usePendingPosSold";

const LOOKBACK_DAYS = 2;

/**
 * ตามเก็บวันที่ "ขายแล้วแต่สต็อกไม่ถูกตัด" ตอนเปิดร้านวันใหม่
 *
 * ที่มา: ถ้าเน็ตหลุดตอนปิดร้าน POS จะยิง /inventories-tx/pos-sold ไม่สำเร็จ
 * ทำให้ businessDate นั้นไม่มี transaction 'pos-closed' และสต็อกไม่ถูกตัดเลยทั้งวัน
 * โดยไม่มีใครรู้ (เคสร้าน charter 2026-08-14 : ขาย 55 บิล สต็อกไม่ขยับสักตัว)
 *
 * fire-and-forget : ยิงครั้งเดียวแล้วจบ ไม่รอผลคำนวณ
 * ฝั่ง server จะโยนงานต่อให้ worker lambda ทำเบื้องหลัง
 * POS เปิดร้านแล้วขายต่อได้ทันที ไม่ต้องรอ
 */
export const useRecoverPosSold = () => {
  /**
   * @param excludeBusinessDate businessDate ที่กำลังจะเปิดขาย ห้ามแตะ
   */
  async function run(storeId: string, excludeBusinessDate: string | null = null) {
    if (!storeId) return false;

    const pendingStore = usePendingPosSold();

    // ส่ง list ที่ค้างบนเครื่องนี้ไปด้วย เผื่อ server ตรวจไม่เจอ
    // (เช่น พังตั้งแต่ตอน sync ใบเสร็จ ทำให้ฝั่ง server ยังไม่มีบิลของวันนั้น)
    const localDates = pendingStore
      .read()
      .filter((p: PendingPosSold) => p.storeId === storeId)
      .map((p: PendingPosSold) => p.businessDate)
      .filter((d: string) => d !== excludeBusinessDate);

    try {
      const res = await dataservice.invetoryTransaction.recoverPosSold({
        storeId,
        lookbackDays: LOOKBACK_DAYS,
        excludeBusinessDate,
        localPendingDates: localDates,
      });

      const status = res?.data?.status;
      if (status === "accepted") {
        // server รับงานไปแล้ว เคลียร์ค้างฝั่งนี้ได้
        localDates.forEach((d: string) => pendingStore.clear(d));
        return true;
      }

      console.warn("useRecoverPosSold: server ไม่รับงาน", status);
      return false;
    } catch (error) {
      // ยิงไม่ถึง (ออฟไลน์) ปล่อยค้างไว้ รอเปิดร้านรอบหน้ามาใหม่
      console.error("useRecoverPosSold: ยิงไม่สำเร็จ", error);
      return false;
    }
  }

  return { run };
};
